const state = {
    user: null
}

const getters = {
    check: state => !! state.user,
    username: state => state.user ? state.user.name : ''
}

const mutations = {
    setUser (state, user) {
        state.user = user && user.email ? user : null
    }
}

const actions = {
    async login (context, data) {
        const response = await axios.post('/api/v1/auth/login', data).catch(error => error.response || null)
        context.commit('setUser', response.data)
        return response
    },
    async logout (context, data) {
        const response = await axios.get('/api/v1/auth/logout', data).catch(error => error.response || null)
        context.commit('setUser', null)
        return response
    },
    async signup (context, data) {
        const response = await axios.post('/api/v1/auth/signup', data).catch(error => error.response || null)
        context.commit('setUser', response.data)
        return response
    },
    async onetimepassword (context, data) {
        const response = await axios.post('/api/v1/auth/onetimepassword', data).catch(error => error.response || null)
        return response
    },
    async newpassword (context, data) {
        const response = await axios.post('/api/v1/auth/newpassword', data).catch(error => error.response || null)
        return response
    },
    async newemail (context, data) {
        const response = await axios.post('/api/v1/auth/newemail', data).catch(error => error.response || null)
        return response
    },
    async closeaccount (context, data) {
        const response = await axios.post('/api/v1/auth/closeaccount', data).catch(error => error.response || null)
        return response
    },



    async me (context) {
        const response = await axios.get('/api/v1/auth/me').catch(error => error.response || null)
        context.commit('setUser', response ? response.data : null)
        return response
    },
    async syncPages (context, data) {
//        this._vm.$set(context.state)
        this._vm.$set(context.state.user.batches, 'sync_pages', {});
        const response = await axios
            .get('/api/v1/auth/sync-pages')
            .catch(error => error.response || null)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


